import React from 'react';
import { observer } from 'mobx-react';
import MapComponent from './Map.component';
import useMap from './useMap';

const Container: React.FC = () => {
    const {
        state,
        coordsList,
        sidebar,
        telemetry,
        groups,
        map,
        lang,
        app,
        user,
        handlers,
    } = useMap();

    return (
        <>
            <MapComponent
                loading={
                    groups.loading ||
                    ((app.page === 'history' || app.page === 'support') &&
                        telemetry.loading)
                }
                zoom={map.zoom}
                page={app.page}
                reload={map.reload}
                coordsList={coordsList}
                isSidebarHidden={sidebar.isSidebarHidden}
                position={map.position}
                cookies={!app.cookiesApproved}
                isTelemetryVisible={telemetry.isTelemetryVisible}
                highlightedDevice={map.highlightedDevice}
                highlightedCoords={map.highlightedCoords}
                highlightedDate={map.highlightedDate}
                timezone={user.settings.timezone ?? 0}
                lang={lang.lang}
                trackMode={map.trackMode}
                lastCoordsList={map.lastCoordsList}
                historyCoordsList={map.historyCoordsList}
                lastBounds={state.lastBounds}
                onMapDrag={handlers.handleMapDrag}
                onMapZoom={handlers.handleMapZoom}
                onSideBarBtnClick={handlers.handleSideBarBtnClick}
                onReload={handlers.handleReload}
                onMapMove={handlers.handleMapMove}
                onDeviceTelemetryOpen={handlers.handleDeviceTelemetryOpen}
            />
        </>
    );
};

const MapContainer = observer(Container);

export default MapContainer;
